import React, { useState, useEffect } from 'react';
import Icon from '../AppIcon';

const FormSectionNavigator = ({ activeForm, onFormChange }) => {
  const [currentLanguage, setCurrentLanguage] = useState('en');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('memorial-language') || 'en';
    setCurrentLanguage(savedLanguage);

    // Listen for language changes
    const handleLanguageChange = (event) => {
      const newLanguage = event.detail?.language || 'en';
      setCurrentLanguage(newLanguage);
    };

    window.addEventListener('languageChanged', handleLanguageChange);
    return () => window.removeEventListener('languageChanged', handleLanguageChange);
  }, []);

  const formSections = {
    ar: [
      {
        id: 'guestbook',
        title: 'لحضور الفعالية',
        description: 'سجِّل للحضور',
        icon: 'Calendar',
        count: '1,247'
      },
      {
        id: 'volunteer',
        title: 'التسجيل كمتطوّع',
        description: 'انضم إلى فريق المتطوعين',
        icon: 'Users',
        count: '342'
      },
      {
        id: 'partner',
        title: 'تقديم الأعمال الفنية',
        description: 'شارك إبداعك الفني',
        icon: 'Palette',
        count: '89'
      }
    ],
    en: [
      {
        id: 'guestbook',
        title: 'To Attend the Event',
        description: 'Register to attend',
        icon: 'Calendar',
        count: '1,247'
      },
      {
        id: 'volunteer',
        title: 'Register as Volunteer',
        description: 'Join the volunteer team',
        icon: 'Users',
        count: '342'
      },
      {
        id: 'partner',
        title: 'Art Submission',
        description: 'Share your artistic creativity',
        icon: 'Palette',
        count: '89'
      }
    ],
    tr: [
      {
        id: 'guestbook',
        title: 'Etkinliğe Katılmak İçin',
        description: 'Katılmak için kayıt ol',
        icon: 'Calendar',
        count: '1,247'
      },
      {
        id: 'volunteer',
        title: 'Gönüllü Olarak Kayıt Ol',
        description: 'Gönüllü ekibine katıl',
        icon: 'Users',
        count: '342'
      },
      {
        id: 'partner',
        title: 'Sanat Eseri Gönderimi',
        description: 'Sanatsal yaratıcılığınızı paylaşın',
        icon: 'Palette',
        count: '89'
      }
    ]
  };

  const sections = formSections?.[currentLanguage] || formSections?.en;

  return (
    <div className="flex flex-col sm:flex-row">
      {sections?.map((section, index) => (
        <button
          key={section?.id}
          onClick={() => onFormChange(section?.id)}
          className={`flex-1 px-4 py-4 text-left memorial-transition border-b-2 sm:border-b-0 sm:border-r last:border-r-0 ${
            activeForm === section?.id
              ? 'bg-primary/5 border-primary text-primary' :'bg-transparent border-border text-text-secondary hover:bg-muted hover:text-text-primary'
          }`}
        >
          <div className="flex items-center space-x-4">
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
              activeForm === section?.id 
                ? 'bg-primary/10' :'bg-muted'
            }`}>
              <Icon 
                name={section?.icon} 
                size={20} 
                className={activeForm === section?.id ? 'text-primary' : 'text-text-secondary'} 
              />
            </div>
            
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between">
                <h3 className="font-body text-sm font-semibold truncate">
                  {section?.title}
                </h3>
                <span className={`text-xs font-medium px-2 py-1 rounded-full ${
                  activeForm === section?.id
                    ? 'bg-primary/10 text-primary' :'bg-muted text-text-secondary'
                }`}>
                  {section?.count}
                </span>
              </div>
              <p className="font-body text-xs text-text-secondary mt-1 truncate">
                {section?.description}
              </p>
            </div>
          </div>
        </button>
      ))}
    </div>
  );
};

export default FormSectionNavigator;